module.exports = __webpack_public_path__ + "img/logo-login.eec0a6a7.png";